import { render, staticRenderFns } from "./MarcaVeiculoDetalhes.vue?vue&type=template&id=ff982612"
import script from "./MarcaVeiculoDetalhes.vue?vue&type=script&lang=js"
export * from "./MarcaVeiculoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports